import {
  OUTLET_PAGE_ASK_REACTIVATE_OUTLET_WITHOUT_PAY,
  OUTLET_PAGE_CONFIRM_REACTIVATE_OUTLET_WITHOUT_PAY,
  OUTLET_PAGE_HIDE_REACTIVATE_OUTLET_WITHOUT_PAY,
  OUTLET_PAGE_LIST_ASK_REACTIVATE_OUTLET,
  OUTLET_PAGE_LIST_CANCEL_REACTIVATE_OUTLET,
  OUTLET_PAGE_LIST_CLICK_ADD_OUTLET,
  OUTLET_PAGE_LIST_CLICK_CANCEL,
  OUTLET_PAGE_LIST_CLICK_CREATE_OUTLET,
  OUTLET_PAGE_LIST_CLICK_OUTLET_ROW,
  OUTLET_PAGE_LIST_CLOSE_RIGHT_COLUMN,
  OUTLET_PAGE_LIST_CONFIRM_REACTIVATE_OUTLET,
  OUTLET_PAGE_LIST_DISABLE_PAY_BUTTON,
  OUTLET_PAGE_LIST_ENABLE_PAY_BUTTON,
  OUTLET_PAGE_LIST_GET_BILLING,
  OUTLET_PAGE_LIST_GET_OUTLET_PRICE,
  OUTLET_PAGE_LIST_GET_SUBSCRIPTION_STATUS,
  OUTLET_PAGE_LIST_HIDE_ADD_OUTLET_MODAL,
  OUTLET_PAGE_LIST_HIDE_CONFIRM_REACTIVATE_OUTLET_MODAL,
  OUTLET_PAGE_LIST_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  OUTLET_PAGE_LIST_OPEN_RIGHT_COLUMN,
  OUTLET_PAGE_LIST_PAGE_REQUEST,
  OUTLET_PAGE_LIST_SEARCH,
  OUTLET_PAGE_LIST_SET_ON_LOADING,
  OUTLET_PAGE_LIST_SET_OUTLET_DETAIL,
  OUTLET_PAGE_LIST_SET_OUTLET_PRICE,
  OUTLET_PAGE_LIST_SET_OUTLET_SLOTS,
  OUTLET_PAGE_LIST_SET_OUTLETS,
  OUTLET_PAGE_LIST_SET_PAY_BUTTON_MESSAGE,
  OUTLET_PAGE_LIST_SET_PENDING_PAYMENT_MESSAGE,
  OUTLET_PAGE_LIST_SET_PROFILE,
  OUTLET_PAGE_LIST_SET_REACTIVATED_OUTLET,
  OUTLET_PAGE_LIST_SET_SUBSCRIPTION_STATUS,
  OUTLET_PAGE_LIST_SET_USED_OUTLET_SLOTS,
  OUTLET_PAGE_LIST_SHOW_ADD_OUTLET_MODAL,
  OUTLET_PAGE_LIST_SHOW_CONFIRM_REACTIVATE_OUTLET_MODAL,
  OUTLET_PAGE_LIST_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
  OUTLET_PAGE_LIST_SUBMIT_FORM_CREATE,
  OUTLET_PAGE_LIST_SUBMIT_FORM_UPDATE,
  OUTLET_PAGE_LIST_VERIFY_ADD_OUTLET_BILLING_DATA,
  OUTLET_PAGE_LIST_SET_DISABLE_SAVE_OUTLET_BUTTON,
  OUTLET_PAGE_SHOW_REACTIVATE_OUTLET_WITHOUT_PAY,
  OUTLET_PAGE_SET_ON_LOADING_REACTIVATE_OUTLET_WITHOUT_PAY_MODAL
} from './constants'

export function pageRequest (billingNotification) {
  return {type: OUTLET_PAGE_LIST_PAGE_REQUEST, payload: {billingNotification}}
}

export function setProfile (profile) {
  return {type: OUTLET_PAGE_LIST_SET_PROFILE, payload: {profile}}
}

/**
 *
 * @param {Array} outlets
 * @return {{type, payload: {outlets: *}}}
 */
export function setOutlets (outlets) {
  return {type: OUTLET_PAGE_LIST_SET_OUTLETS, payload: {outlets}}
}

/**
 *
 * @param {object} outletDetail
 * @return {{type, payload: {outletDetail: *}}}
 */
export function setOutletDetail (outletDetail) {
  return {type: OUTLET_PAGE_LIST_SET_OUTLET_DETAIL, payload: {outletDetail}}
}

export function search (query) {
  return {type: OUTLET_PAGE_LIST_SEARCH, payload: {query}}
}

export function clickOutletRow (outletId) {
  return {type: OUTLET_PAGE_LIST_CLICK_OUTLET_ROW, payload: {outletId}}
}

export function clickCancel () {
  return {type: OUTLET_PAGE_LIST_CLICK_CANCEL, payload: {}}
}

export function clickCreateOutlet () {
  return {type: OUTLET_PAGE_LIST_CLICK_CREATE_OUTLET, payload: {}}
}

export function clickAddOutlet () {
  return {type: OUTLET_PAGE_LIST_CLICK_ADD_OUTLET, payload: {}}
}

export function setOutletSlots (slots) {
  return {type: OUTLET_PAGE_LIST_SET_OUTLET_SLOTS, payload: {slots}}
}

export function setUsedOutletSlots (slots) {
  return {type: OUTLET_PAGE_LIST_SET_USED_OUTLET_SLOTS, payload: {slots}}
}

export function submitFormCreate (data, params, previousOutlets) {
  return {type: OUTLET_PAGE_LIST_SUBMIT_FORM_CREATE, payload: {data, params, previousOutlets}}
}

export function submitFormUpdate (outletId, data, params, previousOutlets) {
  return {type: OUTLET_PAGE_LIST_SUBMIT_FORM_UPDATE, payload: {outletId, data, params, previousOutlets}}
}

export function showConfirmReactivateOutletModal () {
  return {type: OUTLET_PAGE_LIST_SHOW_CONFIRM_REACTIVATE_OUTLET_MODAL, payload: {}}
}

export function hideConfirmReactivateOutletModal () {
  return {type: OUTLET_PAGE_LIST_HIDE_CONFIRM_REACTIVATE_OUTLET_MODAL, payload: {}}
}

export function askReactivateOutlet (outlet) {
  return {type: OUTLET_PAGE_LIST_ASK_REACTIVATE_OUTLET, payload: {outlet}}
}

export function cancelReactivateOutlet () {
  return {type: OUTLET_PAGE_LIST_CANCEL_REACTIVATE_OUTLET, payload: {}}
}

export function confirmReactivateOutlet (billingData) {
  return {type: OUTLET_PAGE_LIST_CONFIRM_REACTIVATE_OUTLET, payload: {billingData}}
}

export function setReactivatedOutlet (outlet) {
  return {type: OUTLET_PAGE_LIST_SET_REACTIVATED_OUTLET, payload: {outlet}}
}

export function openRightColumn () {
  return {type: OUTLET_PAGE_LIST_OPEN_RIGHT_COLUMN, payload: {}}
}

export function closeRightColumn () {
  return {type: OUTLET_PAGE_LIST_CLOSE_RIGHT_COLUMN, payload: {}}
}

export function showAddOutletModal () {
  return {type: OUTLET_PAGE_LIST_SHOW_ADD_OUTLET_MODAL}
}

export function hideAddOutletModal () {
  return {type: OUTLET_PAGE_LIST_HIDE_ADD_OUTLET_MODAL}
}

export function getOutletPrice () {
  return {type: OUTLET_PAGE_LIST_GET_OUTLET_PRICE}
}

export function setOutletPrice (outletPrice) {
  return {type: OUTLET_PAGE_LIST_SET_OUTLET_PRICE, payload: {outletPrice}}
}

export function getFeatureSubscriptionStatus () {
  return {type: OUTLET_PAGE_LIST_GET_SUBSCRIPTION_STATUS}
}

export function setFeatureSubscriptionStatus (featureSubscriptions) {
  return {type: OUTLET_PAGE_LIST_SET_SUBSCRIPTION_STATUS, payload: {featureSubscriptions}}
}

export function verifyAddOutletBilling (billingData) {
  return {type: OUTLET_PAGE_LIST_VERIFY_ADD_OUTLET_BILLING_DATA, payload: {billingData}}
}

export function showPaymentGatewayError () {
  return {type: OUTLET_PAGE_LIST_SHOW_PAYMENT_GATEWAY_ERROR_MODAL}
}

export function hidePaymentGatewayError () {
  return {type: OUTLET_PAGE_LIST_HIDE_PAYMENT_GATEWAY_ERROR_MODAL}
}

export function setPaymentButtonMessage (buttonMessage) {
  return {type: OUTLET_PAGE_LIST_SET_PAY_BUTTON_MESSAGE, payload: {buttonMessage}}
}

export function enablePayButton () {
  return {type: OUTLET_PAGE_LIST_ENABLE_PAY_BUTTON}
}

export function disablePayButton () {
  return {type: OUTLET_PAGE_LIST_DISABLE_PAY_BUTTON}
}

export function setPendingPaymentMessage (pendingMessage) {
  return {type: OUTLET_PAGE_LIST_SET_PENDING_PAYMENT_MESSAGE, payload: {pendingMessage}}
}

export function getBilling () {
  return {type: OUTLET_PAGE_LIST_GET_BILLING}
}

export function setOnLoading (onLoading) {
  return {type: OUTLET_PAGE_LIST_SET_ON_LOADING, payload: {onLoading}}
}

export function setDisableSaveOutletButton (disabled) {
  return {type: OUTLET_PAGE_LIST_SET_DISABLE_SAVE_OUTLET_BUTTON, payload: {disabled}}
}

export function askReactivateOutletWithoutPay (outlet) {
  return {type: OUTLET_PAGE_ASK_REACTIVATE_OUTLET_WITHOUT_PAY, payload: {outlet}}
}

export function confirmReactivateOutletWithoutPay (outlet, previousOutlets) {
  return {type: OUTLET_PAGE_CONFIRM_REACTIVATE_OUTLET_WITHOUT_PAY, payload: {outlet, previousOutlets}}
}

export function showReactivateOutletWithoutPay () {
  return {type: OUTLET_PAGE_SHOW_REACTIVATE_OUTLET_WITHOUT_PAY}
}

export function hideReactivateOutletWithoutPay () {
  return {type: OUTLET_PAGE_HIDE_REACTIVATE_OUTLET_WITHOUT_PAY}
}

export function setOnLoadingReactivateOutletWithoutPay (isOnLoading) {
  return {type: OUTLET_PAGE_SET_ON_LOADING_REACTIVATE_OUTLET_WITHOUT_PAY_MODAL, payload: {isOnLoading}}
}



// WEBPACK FOOTER //
// ./app/actions/outletPages/list/list.js